import { Squash } from "hamburger-react";
import React, { useState } from "react";
import { HamburgerLinks } from "./HambugerLinks";
import { HamburgerContainer } from "./style";

export const MenuMobile = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <HamburgerContainer>
      <Squash toggled={isOpen} toggle={setIsOpen} />
      {isOpen && <HamburgerLinks toggled={isOpen} toggle={setIsOpen} />}
    </HamburgerContainer>
  );
};
